import { useEffect, type MutableRefObject } from 'react'

import useThemeContext from '@space-shell/common/hooks/useThemeContext'
import { css } from 'styled-components'

const arrowStyles = css<{ theme: string }>`
  .hc-collapse-item header {
    --hc-collapse-item-header-gap: 0;
    --hc-collapse-item-active-transform: rotate(0deg);
  }

  .hc-collapse-item header::after {
    --hc-collapse-item-opener-margin-top: 0;
    background-repeat: no-repeat !important;
    background-position: center center !important;
    background-size: 85% !important;
    padding: 0.75rem 0.25rem;
    transform: rotate(-180deg);
  }

  .hc-collapse-item__title {
    align-items: center;
    width: 100%;
  }
`

export function useShadowRef(shadowRootRef: MutableRefObject<HTMLHcCollapseItemElement> | null) {
  const { theme } = useThemeContext()

  useEffect(() => {
    if (shadowRootRef?.current) {
      const shadowRoot = shadowRootRef.current.shadowRoot
      const customStylesWrapper = shadowRoot?.querySelector('#custom-collapse-styles')
      const customCollapseStyles = arrowStyles.toString()

      if (!customStylesWrapper) {
        const styles = document.createElement('style')
        styles.id = 'custom-collapse-styles'
        styles.innerHTML = customCollapseStyles
        shadowRoot?.prepend(styles)
      } else {
        customStylesWrapper.innerHTML = customCollapseStyles
      }
    }
  }, [shadowRootRef, theme])

  return { shadowRootRef }
}
